import PropTypes from 'prop-types';
import { extendObservable } from 'mobx';
import BrowsingRolesStore from './BrowsingRoles/BrowsingRolesStore';
import OverviewStore from './OverviewStore';
import RedirectRulesStore from './RedirectRules/RedirectRulesStore';
import ContentRulesStore from './ContentRules/ContentRulesStore';
import CustomCategoriesStore from './CustomCategories/CustomCategoriesStore';
import ExclusionRulesStore from './ExclusionRules/ExclusionRulesStore';
import AccessCodesStore from './AccessCodes/AccessCodesStore';
import PolicyTestingStore from './PolicyTesting/PolicyTestingStore';
import FileThreatRulesStore from './FileRules/FileThreatRules/FileThreatRulesStore';
import DlpRulesStore from './FileRules/DlpRules/DlpRulesStore';

export default class PolicyStore {
    static PropType = PropTypes.shape({
        overview: OverviewStore.PropType.isRequired,
        browsingRoles: BrowsingRolesStore.PropType.isRequired,
        redirectRules: RedirectRulesStore.PropType.isRequired,
        contentRules: ContentRulesStore.PropType.isRequired,
        customCategories: CustomCategoriesStore.PropType.isRequired,
        exclusionRules: ExclusionRulesStore.PropType.isRequired,
        fileThreatRules: FileThreatRulesStore.PropType.isRequired,
        dlpRules: DlpRulesStore.PropType.isRequired,
        accessCodes: AccessCodesStore.PropType.isRequired,
        policyTesting: PolicyTestingStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class PolicyStore */{
            overview: new OverviewStore(),
            browsingRoles: new BrowsingRolesStore(),
            redirectRules: new RedirectRulesStore(),
            contentRules: new ContentRulesStore(),
            customCategories: new CustomCategoriesStore(),
            exclusionRules: new ExclusionRulesStore(),
            fileThreatRules: new FileThreatRulesStore(),
            dlpRules: new DlpRulesStore(),
            accessCodes: new AccessCodesStore(),
            policyTesting: new PolicyTestingStore()
        }, data);
    }
}
